import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useApi} from "../ApiSession";
import {DefaultButton} from "../widgets/Buttons";



const Login = ({}) => {

    const [email, setEmail] = useState('')

    const [password, setPassword] = useState('')

    const [canLogin, setCanLogin] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')

    const navigate = useNavigate()

    const api = useApi()

    const resetErrorMessage = () => setErrorMessage('')

    const doLogin = () =>
        api.login(email, password).catch(response => {
            setErrorMessage("Échec, mot de passe ou courriel invalide")
            return Promise.reject(response)
        }).then(res => {
            navigate("/")
        })

    useEffect(() => {
        setCanLogin((email.length > 2) && (password.length > 3))
    },[`${email}-${password}`])

    return <form className="max-w-sm mx-auto">
        <div>
            {errorMessage && <span className="text-red-500">{errorMessage}</span>}
        </div>
        <div className="mb-5">
            <label
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
                Courriel</label>
            <input
                type="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder=""
                onChange={e => {
                    setEmail(e.target.value)
                    resetErrorMessage()
                }}
            />
        </div>
        <div className="mb-5">
            <label
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
                Mot de passe
            </label>
            <input
                type="password"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={e => {
                    setPassword(e.target.value)
                    resetErrorMessage()
                }}
                onKeyPress={event => {
                    if (event.key === 'Enter' && canLogin) {
                      doLogin()
                    }
                }}
            />
        </div>
        <DefaultButton onClick={doLogin} caption={"Login"}/>
    </form>
}

export default Login